import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { ControlCard, logContentCardClick, logContentCardImpressions } from "../Card/index.js";
import { requestContentCardsRefresh } from "./request-content-cards-refresh.js";
var ContentCards = /*#__PURE__*/function () {
  function ContentCards(r, t) {
    _classCallCheck(this, ContentCards);
    this.cards = r, this.lastUpdated = t, this.cards = r, this.lastUpdated = t;
  }
  _createClass(ContentCards, [{
    key: "getUnviewedCardCount",
    value: function getUnviewedCardCount() {
      var r = 0;
      var _iterator = _createForOfIteratorHelper(this.cards),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var t = _step.value;
          t.viewed || t instanceof ControlCard || r++;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return r;
    }
  }, {
    key: "sr",
    value: function sr(r) {
      logContentCardImpressions(r);
    }
  }, {
    key: "nr",
    value: function nr(r) {
      return logContentCardClick(r);
    }
  }, {
    key: "dr",
    value: function dr() {
      requestContentCardsRefresh();
    }
  }, {
    key: "ar",
    value: function ar() {
      return !0;
    }
  }]);
  return ContentCards;
}();
export { ContentCards as default };
ContentCards.ur = 6e4, ContentCards.cr = 500, ContentCards.Cr = 1e4;